import { render, staticRenderFns } from "./mgmtDoctors.vue?vue&type=template&id=4a33b7b2&scoped=true&"
import script from "./mgmtDoctors.vue?vue&type=script&lang=js&"
export * from "./mgmtDoctors.vue?vue&type=script&lang=js&"
import style0 from "./mgmtDoctors.vue?vue&type=style&index=0&id=4a33b7b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a33b7b2",
  null
  
)

export default component.exports